import { SVGFC } from '@repo/toolkit/types'

const Email2Icon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.5 10.5713V7.78563C18.5 6.24717 17.2408 5 15.6875 5H6.3125C4.7592 5 3.5 6.24717 3.5 7.78563V15.214C3.5 16.7525 4.7592 17.9996 6.3125 17.9996H11.9375"
        stroke={color}
        strokeWidth="1.01586"
        strokeLinecap="round"
      />
      <path
        d="M6.3125 7.78516L10.7072 11.2673C10.8784 11.4029 11.1216 11.4029 11.2928 11.2673L15.6875 7.78516"
        stroke={color}
        strokeWidth="1.01586"
        strokeLinecap="round"
      />
      <path
        d="M15.2579 12.9365H16.1171V17.0623C16.1171 17.2996 15.9247 17.4919 15.6875 17.4919C15.4503 17.4919 15.2579 17.2996 15.2579 17.0623V12.9365Z"
        stroke={color}
        strokeWidth="1.01586"
      />
      <path
        d="M13.8125 16.1406L15.356 17.6694C15.5391 17.8507 15.8359 17.8507 16.019 17.6694L17.5625 16.1406"
        stroke={color}
        strokeWidth="1.01586"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Email2Icon
